interface FrameRouteTarget {
  icid?: string | null;
  index: number;
}

export const getFrameRoute = (studyIcid: string, dicomIcid: string, frame: FrameRouteTarget) =>
  frame.icid
    ? `/${studyIcid}/${dicomIcid}/${frame.icid}`
    : `/${studyIcid}/${dicomIcid}/frame/${frame.index}`;
